import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fil from "./locales/fil.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import id from "./locales/id.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import pt from "./locales/pt.json";
import zh from "./locales/zh.json";

const LANGUAGE_KEY = "VWA:language";

const resources = {
  ar: {
    translation: ar,
  },
  de: {
    translation: de,
  },

  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
  fil: {
    translation: fil,
  },
  fr: {
    translation: fr,
  },
  hi: {
    translation: hi,
  },
  id: {
    translation: id,
  },
  ja: {
    translation: ja,
  },
  ko: {
    translation: ko,
  },
  pt: {
    translation: pt,
  },
  zh: {
    translation: zh,
  },
};

const supportedLanguages = Object.keys(resources);

const getBrowserLanguage = () => {
  const browserLanguage =
    navigator.language?.split("-")[0]?.toLowerCase() || "en";

  return supportedLanguages.includes(browserLanguage) ? browserLanguage : "en";
};

export const initializeI18n = async () => {
  // 1. Check saved language
  const savedLanguage = localStorage.getItem(LANGUAGE_KEY);

  // 2. Use saved language or detect user language
  const language =
    savedLanguage && supportedLanguages.includes(savedLanguage)
      ? savedLanguage
      : getBrowserLanguage();

  // 3. Initialize
  await i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: "en",
    compatibilityJSON: "v4",
    interpolation: {
      escapeValue: false,
    },
  });

  return language;
};

export const changeLanguage = async (language) => {
  if (!supportedLanguages.includes(language)) {
    return;
  }

  await i18n.changeLanguage(language);

  localStorage.setItem(LANGUAGE_KEY, language);

  localStorage.setItem("VWA:ftu", "1");
};

export const getCurrentLanguage = async () => {
  const savedLanguage = localStorage.getItem(LANGUAGE_KEY);

  const language =
    savedLanguage && supportedLanguages.includes(savedLanguage)
      ? savedLanguage
      : getBrowserLanguage();

  return allLanguagesObject[language];
};

export const getCurrentLanguageRaw = async () => {
  const savedLanguage = localStorage.getItem(LANGUAGE_KEY);

  const language =
    savedLanguage && supportedLanguages.includes(savedLanguage)
      ? savedLanguage
      : getBrowserLanguage();

  return language;
};

export const allLanguagesSearch = [
  { name: "Arabic", label: "ar" },
  { name: "Chinese(Simplified)", label: "zh" },
  { name: "English", label: "en" },
  { name: "Filipino", label: "fil" },

  { name: "French", label: "fr" },

  { name: "German", label: "de" },

  { name: "Hindi", label: "hi" },

  { name: "Indonesian", label: "id" },

  { name: "Japanese", label: "ja" },

  { name: "Korean", label: "ko" },

  { name: "Portuguese", label: "pt" },

  { name: "Spanish", label: "es" },
];

export const allLanguagesObject = {
  ar: "Arabic	(ar)",
  zh: "Chinese(Simplified)	(zh)",
  en: "English	(en)",
  fil: "Filipino	(fil)",
  fr: "French	(fr)",
  de: "German	(de)",
  hi: "Hindi	(hi)",
  id: "Indonesian	(id)",
  ja: "Japanese	(ja)",
  ko: "Korean	(ko)",
  pt: "Portuguese	(pt)",
  es: "Spanish	(es)",
};
